export default __webpack_public_path__ + "static/wbc-cbd653e0413c33817ffa18503c8f4aba.jpg";